import { render, staticRenderFns } from "./WwsStudentBulkIcardPrint.vue?vue&type=template&id=2aec8738&scoped=true&"
import script from "./WwsStudentBulkIcardPrint.vue?vue&type=script&lang=js&"
export * from "./WwsStudentBulkIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./WwsStudentBulkIcardPrint.vue?vue&type=style&index=0&id=2aec8738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec8738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
